// =============================================================================
// ConnView.ts — Aviso de queda de conexão (issue #72): cobre qualquer tela
// enquanto o Socket.IO tenta reconectar e, se a sala morreu no reinício do
// servidor (deploy), avisa que o pleito foi anulado antes de voltar ao menu.
// Ícones em pixel art (antena sem sinal / seta de atualização) no index.html.
// =============================================================================
import { $, $in, type Overlay } from './dom';

export class ConnView implements Overlay {
  // Raiz única do overlay: todos os ids desta view moram dentro do #conn-overlay
  readonly root: HTMLElement = $('conn-overlay');
  private readonly q = $in(this.root);

  // Servidor sumiu (deploy? wifi?): o Socket.IO já está tentando de novo
  showReconnecting(): void {
    this.q('conn-icon-drop').style.display = '';
    this.q('conn-icon-update').style.display = 'none';
    this.q('conn-title').textContent = 'CAIU O SISTEMA!';
    this.q('conn-msg').textContent = 'Reconectando com o TSE... segure a urna.';
    this.q('conn-msg').classList.add('blink');
    this.root.style.display = '';
  }

  // Conexão voltou mas a sala não existe mais (servidor foi atualizado)
  showEnded(): void {
    this.q('conn-icon-drop').style.display = 'none';
    this.q('conn-icon-update').style.display = '';
    this.q('conn-title').textContent = 'O SISTEMA FOI ATUALIZADO';
    this.q('conn-msg').textContent = 'O servidor reiniciou e o pleito foi anulado. Voltando às urnas...';
    this.q('conn-msg').classList.remove('blink');
    this.root.style.display = '';
  }

  hide(): void {
    this.root.style.display = 'none';
  }

  visible(): boolean {
    return this.root.style.display !== 'none';
  }
}
